import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/header.css"; // optional CSS styling file

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">🌟 MyApp</Link>
      </div>
      <nav className={isMobileMenuOpen ? "nav-links mobile-open" : "nav-links"}>
        {/* <Link to="/prodlist">Home</Link> */}
        <Link to="/users">Users</Link>
        <Link to="/about">About</Link>
        <Link to="/services">Services</Link>
        <Link to="/contact">Contact</Link>
      </nav>
      <button className="menu-toggle" onClick={toggleMenu}>
        ☰
      </button>
    </header>
  );
};

export default Header;
